<script>
import darkBtn from "../ui/darkBtn.vue";
import BurgerMenuAcc from "./BurgerMenuAcc.vue";
import { myNameUser } from "@/mixinOld";
import Cookies from "js-cookie";
export default {
  name: "HeaderAcc",
  components: {
    darkBtn,
    BurgerMenuAcc
  },
  mixins: [myNameUser],
  data() {
    return {
      user2: this.user,
      reName: "",
      isActive: false,
      isUserMenu: false,
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true
    }
  },
  methods: {
    activeEl(id) {
      document.querySelector(id).classList.add("active");
    },
    removeEl(id) {
      document.querySelector(id).classList.remove("active");
    },
    toggleActive() {
      this.isActive = !this.isActive;
      this.toggleBodyClass();
    },
    toggleUserMenu() {
      let body = document.querySelector("body");
      body.removeEventListener("click", this.handleClickOutside);
      this.isUserMenu = !this.isUserMenu;
      if (this.isUserMenu) {
        body.addEventListener("click", this.handleClickOutside);
      }
    },
    handleClickOutside(event) {
      const userMenu = this.$el.querySelector('.user-menu');
      if (userMenu && !userMenu.contains(event.target)) {
        this.isUserMenu = false;
      }
    },
    toggleBodyClass() {
      if (this.isActive) {
        document.body.classList.add("overflow");
      } else {
        document.body.classList.remove("overflow");
      }
    },
    closeMenu() {
      this.isActive = false;
      this.toggleBodyClass();
    },
    logout() {
      Cookies.remove("user");
      this.$router.push('/');
    },
  },
  mounted() {
    console.log(this.user);
    
  }
};
</script>

<template>
  <div class="headerAcc" @click="handleClickOutside">
    <div class="searchInput" :id="'searchInput'" @mouseover="activeEl('.body')" @mouseleave="removeEl('.body')">
      <input type="text" class="search_Input" placeholder="Введите запрос..." />
      <button class="searchBtn">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
            stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path opacity="0.4"
            d="M18.9299 20.6888C19.4599 22.2888 20.6699 22.4488 21.5999 21.0488C22.4499 19.7688 21.8899 18.7188 20.3499 18.7188C19.2099 18.7088 18.5699 19.5988 18.9299 20.6888Z"
            stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
    <div class="links">
      <div class="links__items">
        <div class="links__item">
          <span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.4"
                d="M20.9099 11.12C20.9099 16.01 17.3599 20.59 12.5099 21.93C12.1799 22.02 11.8198 22.02 11.4898 21.93C6.63984 20.59 3.08984 16.01 3.08984 11.12V6.73003C3.08984 5.91003 3.70986 4.98004 4.47986 4.67004L10.0498 2.39007C11.2998 1.88007 12.7098 1.88007 13.9598 2.39007L19.5298 4.67004C20.2898 4.98004 20.9199 5.91003 20.9199 6.73003L20.9099 11.12Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M10.0399 2.39007C11.2899 1.88007 12.6999 1.88007 13.9499 2.39007L19.5198 4.67004C20.2798 4.98004 20.9099 5.91003 20.9099 6.73003V11.12C20.9099 16.01 17.3599 20.59 12.5099 21.93C12.1799 22.02 11.8198 22.02 11.4898 21.93C6.63984 20.59 3.08984 16.01 3.08984 11.12"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path opacity="0.4" d="M9.05078 11.8702L10.6608 13.4802L14.9608 9.18018" stroke="white" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          Чат с поддержкой
        </div>
        <div v-if="this.user" class="links__item">
          <div class="links__item-wrap" @click.stop="toggleUserMenu">
            <span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4"
                  d="M12.1605 10.87C12.0605 10.86 11.9405 10.86 11.8305 10.87C9.45055 10.79 7.56055 8.84 7.56055 6.44C7.56055 3.99 9.54055 2 12.0005 2C14.4505 2 16.4405 3.99 16.4405 6.44C16.4305 8.84 14.5405 10.79 12.1605 10.87Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M7.1607 14.56C4.7407 16.18 4.7407 18.82 7.1607 20.43C9.9107 22.27 14.4207 22.27 17.1707 20.43C19.5907 18.81 19.5907 16.17 17.1707 14.56C14.4307 12.73 9.9207 12.73 7.1607 14.56Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            {{ getShortFullName(this.user, "fam i.o.") }}
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.9405 6.7124L10.0505 11.6024C9.47305 12.1799 8.52805 12.1799 7.95055 11.6024L3.06055 6.7124"
                stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div :class="['user-menu', { active: isUserMenu }]">
            <router-link to="">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#1A1A1A"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <g opacity="0.4">
                  <path d="M15.5703 18.4996V14.5996" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5703 7.45V5.5" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M15.5687 12.6502C17.0047 12.6502 18.1687 11.4861 18.1687 10.0502C18.1687 8.61426 17.0047 7.4502 15.5687 7.4502C14.1328 7.4502 12.9688 8.61426 12.9688 10.0502C12.9688 11.4861 14.1328 12.6502 15.5687 12.6502Z"
                    stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M8.42969 18.4998V16.5498" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.42969 9.4V5.5" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M8.43008 16.5496C9.86602 16.5496 11.0301 15.3855 11.0301 13.9496C11.0301 12.5137 9.86602 11.3496 8.43008 11.3496C6.99414 11.3496 5.83008 12.5137 5.83008 13.9496C5.83008 15.3855 6.99414 16.5496 8.43008 16.5496Z"
                    stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
              </svg>
              Настройки
            </router-link>
            <router-link to="">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.34" d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z"
                  stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z"
                  stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path opacity="0.34"
                  d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z"
                  stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z"
                  stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              Наши продукты
            </router-link>
            <a @click="logout">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.4">
                  <path d="M17.4395 14.62L19.9995 12.06L17.4395 9.5" stroke="#1A1A1A" stroke-width="1.5"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.75977 12.0596H19.9298" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <path d="M11.7598 20C7.33977 20 3.75977 17 3.75977 12C3.75977 7 7.33977 4 11.7598 4" stroke="#1A1A1A"
                  stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Выйти
            </a>
          </div>
        </div>
      </div>
      <div class="btns__items">
        <dark-btn>
          <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 25H15C20 25 22 23 22 18V12C22 7 20 5 15 5H9C4 5 2 7 2 12V18C2 23 4 25 9 25Z" stroke="white"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M15.75 12H8.25" stroke="white" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path opacity="0.4" d="M15.75 18H8.25" stroke="white" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <circle cx="22" cy="5" r="4" fill="#41C75F" stroke="#1A1A1A" stroke-width="2" />
          </svg>
          Контракты
        </dark-btn>
        <a class="burger" :class="{ active: isActive }" @click="toggleActive">
          <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H19" stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <path opacity="0.34" d="M1 6H19" stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <path d="M1 11H19" stroke="white" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </a>

      </div>
    </div>
    <div class="mob">
      <router-link to="">
        <svg width="133" height="38" viewBox="0 0 133 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 38C8.49128 38 0 29.4786 0 19C0 8.49127 8.52139 0 19 0C29.5087 0 38 8.52139 38 19C38.0301 29.5087 29.5087 38 19 38Z"
            fill="#7700FF" />
          <path d="M20.7178 20.8066H17.2852V26.6482H20.7178V20.8066Z" fill="#E7ECEE" />
          <path d="M30.1469 11.3164L17.2656 24.1978L19.6928 26.625L32.5742 13.7437L30.1469 11.3164Z" fill="#E7ECEE" />
          <path d="M32.6116 23.2156H17.2852V26.6482H32.6116V23.2156Z" fill="#E7ECEE" />
          <path d="M18.3169 11.3491L5.43555 24.2305L7.86277 26.6577L20.7441 13.7764L18.3169 11.3491Z" fill="#E7ECEE" />
          <path d="M20.7171 11.3523H5.39062V14.7849H20.7171V11.3523Z" fill="#E7ECEE" />
          <path d="M20.7178 11.3218H17.2852V17.1633H20.7178V11.3218Z" fill="#E7ECEE" />
          <path
            d="M55.7655 9.33441C53.5674 9.33441 52.4533 9.72585 52.4533 10.5087C52.4533 10.8701 52.634 11.111 52.9652 11.2916C53.2964 11.4422 53.8987 11.5626 54.7719 11.6228L57.7529 11.8035C59.5595 11.9541 60.8844 12.2853 61.6974 12.8273C62.5104 13.3693 62.9319 14.1522 62.9319 15.2361C62.9319 16.5008 62.3297 17.4945 61.1253 18.187C59.9208 18.8796 58.1443 19.2108 55.8258 19.2108C53.6578 19.2108 52.0017 18.9097 50.8876 18.3376C49.7735 17.7354 49.0508 16.8019 48.6895 15.477L52.0017 14.9953C52.1522 15.6276 52.5437 16.1094 53.1459 16.4105C53.7481 16.7116 54.6213 16.8621 55.7354 16.8621C58.2045 16.8621 59.4692 16.4406 59.4692 15.6276C59.4692 15.2362 59.3186 14.9652 58.9874 14.8146C58.6562 14.664 58.1142 14.5436 57.2711 14.4533L54.26 14.2726C52.4834 14.1522 51.1586 13.7908 50.3155 13.2187C49.4723 12.6466 49.0508 11.8336 49.0508 10.7797C49.0508 9.60541 49.6229 8.67197 50.7972 8.00953C51.9715 7.34709 53.5975 7.01587 55.7053 7.01587C57.783 7.01587 59.3788 7.31698 60.5231 7.88908C61.6372 8.46119 62.3598 9.36453 62.6609 10.5389L59.3788 11.0206C59.2584 10.4485 58.8971 10.027 58.325 9.75597C57.7528 9.48497 56.9097 9.33441 55.7655 9.33441Z"
            fill="#7700FF" />
          <path
            d="M72.628 19.2409C70.189 19.2409 68.2619 18.6989 66.9069 17.6149C65.5218 16.5309 64.8594 15.0254 64.8594 13.1284C64.8594 11.2314 65.5519 9.72585 66.9069 8.64186C68.292 7.55786 70.189 7.01587 72.628 7.01587C75.067 7.01587 76.9941 7.55786 78.3491 8.64186C79.704 9.72585 80.3966 11.2314 80.3966 13.1284C80.3966 15.0555 79.704 16.561 78.3491 17.645C76.9941 18.6989 75.0971 19.2409 72.628 19.2409ZM72.628 16.561C75.4283 16.561 76.8134 15.4168 76.8134 13.1284C76.8134 10.84 75.4283 9.69574 72.628 9.69574C69.8277 9.69574 68.4426 10.84 68.4426 13.1284C68.4426 15.4168 69.8277 16.561 72.628 16.561Z"
            fill="#1A1A1A" />
          <path
            d="M86.448 19H83.3164V2.89062H86.8394V9.24403C87.4416 8.52137 88.1944 7.97937 89.1278 7.58793C90.0613 7.19649 91.0851 6.98571 92.2293 6.98571C94.2467 6.98571 95.8727 7.52771 97.047 8.64182C98.2213 9.75592 98.8235 11.2314 98.8235 13.0982C98.8235 14.9651 98.2213 16.4707 97.047 17.5547C95.8727 18.6688 94.2467 19.2108 92.2293 19.2108C91.0248 19.2108 89.9709 19 89.0074 18.5784C88.0438 18.1569 87.261 17.5547 86.6587 16.8019L86.448 19ZM91.1452 16.5008C92.5002 16.5008 93.524 16.1997 94.2166 15.6276C94.9091 15.0253 95.2705 14.2123 95.2705 13.1283C95.2705 12.0443 94.9091 11.2012 94.2166 10.6291C93.524 10.057 92.5002 9.72581 91.1452 9.72581C89.7903 9.72581 88.7364 10.0269 87.9836 10.6291C87.2308 11.2314 86.8394 12.0745 86.8394 13.1283C86.8394 14.1822 87.2308 15.0253 87.9836 15.6276C88.7364 16.1997 89.7903 16.5008 91.1452 16.5008Z"
            fill="#1A1A1A" />
          <path
            d="M108.731 19.2409C106.292 19.2409 104.395 18.6989 102.98 17.5848C101.595 16.5008 100.902 14.9953 100.902 13.0983C100.902 11.2615 101.595 9.78607 102.98 8.67197C104.365 7.55787 106.262 7.01587 108.671 7.01587C110.207 7.01587 111.531 7.25675 112.676 7.70842C113.82 8.16008 114.693 8.85264 115.325 9.72585C115.958 10.5991 116.259 11.6228 116.259 12.7972C116.259 13.1886 116.199 13.5801 116.108 14.0016H104.395C104.726 15.8083 106.172 16.7116 108.731 16.7116C111.02 16.7116 112.345 16.1696 112.736 15.0555L116.138 15.6577C115.747 16.8923 114.934 17.7956 113.76 18.3978C112.585 18.9398 110.929 19.2409 108.731 19.2409ZM108.701 9.51507C106.322 9.51507 104.907 10.298 104.486 11.8938H112.796C112.435 10.298 111.05 9.51507 108.701 9.51507Z"
            fill="#1A1A1A" />
          <path
            d="M124.961 9.33441C122.763 9.33441 121.649 9.72585 121.649 10.5087C121.649 10.8701 121.829 11.111 122.161 11.2916C122.492 11.4422 123.094 11.5626 123.967 11.6228L126.948 11.8035C128.755 11.9541 130.08 12.2853 130.893 12.8273C131.706 13.3693 132.127 14.1522 132.127 15.2361C132.127 16.5008 131.525 17.4945 130.321 18.187C129.116 18.8796 127.34 19.2108 125.021 19.2108C122.853 19.2108 121.197 18.9097 120.083 18.3376C118.969 17.7354 118.246 16.8019 117.885 15.477L121.197 14.9953C121.348 15.6276 121.739 16.1094 122.341 16.4105C122.943 16.7116 123.817 16.8621 124.931 16.8621C127.4 16.8621 128.664 16.4406 128.664 15.6276C128.664 15.2362 128.514 14.9652 128.183 14.8146C127.851 14.664 127.309 14.5436 126.466 14.4533L123.455 14.2726C121.679 14.1522 120.354 13.7908 119.511 13.2187C118.668 12.6466 118.246 11.8336 118.246 10.7797C118.246 9.60541 118.818 8.67197 119.993 8.00953C121.167 7.34709 122.793 7.01587 124.901 7.01587C126.978 7.01587 128.574 7.31698 129.718 7.88908C130.832 8.46119 131.555 9.36453 131.856 10.5389L128.574 11.0206C128.454 10.4485 128.092 10.027 127.52 9.75597C126.978 9.48497 126.105 9.33441 124.961 9.33441Z"
            fill="#1A1A1A" />
          <path d="M49.1719 28.3342V27.7019H52.755V28.3342H51.3097V31.4658H50.6172V28.3342H49.1719Z" fill="#1A1A1A" />
          <path
            d="M54.2609 33.0918H53.5684V27.702H54.2609V28.0934C54.562 27.7622 54.9836 27.5815 55.5256 27.5815C56.1278 27.5815 56.5794 27.7622 56.9107 28.1537C57.2419 28.5451 57.4225 28.9968 57.4225 29.5388C57.4225 30.0808 57.2419 30.5625 56.9107 30.9239C56.5794 31.3153 56.0977 31.496 55.5256 31.496C54.9836 31.496 54.562 31.3153 54.2609 30.9841V33.0918ZM54.6222 28.6053C54.3814 28.8462 54.2609 29.1473 54.2609 29.599C54.2609 30.0205 54.3814 30.3517 54.6222 30.5926C54.8631 30.8335 55.1642 30.9239 55.5256 30.9239C55.8869 30.9239 56.1579 30.8034 56.3988 30.5324C56.6397 30.2614 56.73 29.9603 56.73 29.599C56.73 29.2376 56.6096 28.9064 56.3988 28.6655C56.188 28.4247 55.8869 28.2741 55.5256 28.2741C55.1642 28.244 54.8631 28.3644 54.6222 28.6053Z"
            fill="#1A1A1A" />
          <path
            d="M59.9813 27.6118C60.5233 27.6118 60.9449 27.7323 61.2761 28.0033C61.6073 28.2743 61.7578 28.6055 61.7578 29.0872V31.466H61.0653V31.0746C60.7642 31.4058 60.3125 31.5864 59.7705 31.5864C59.3189 31.5864 58.9575 31.466 58.6564 31.2552C58.3854 31.0445 58.2349 30.7434 58.2349 30.3218C58.2349 29.9002 58.3854 29.5991 58.6865 29.3884C58.9877 29.2077 59.3791 29.0872 59.8609 29.0872H61.0352C61.0352 28.5151 60.6738 28.2441 59.9512 28.2441C59.7103 28.2441 59.4995 28.3044 59.3189 28.3947C59.1382 28.485 58.9876 28.6356 58.9274 28.7861H58.1445C58.2349 28.4248 58.4758 28.1237 58.807 27.9129C59.1382 27.7021 59.5296 27.6118 59.9813 27.6118ZM61.0653 29.9605V29.7196H59.891C59.2587 29.7196 58.9575 29.9304 58.9575 30.3218C58.9575 30.7132 59.2587 30.924 59.8609 30.924C60.2222 30.924 60.5233 30.8337 60.7642 30.653C60.9449 30.4723 61.0653 30.2315 61.0653 29.9605Z"
            fill="#1A1A1A" />
          <path
            d="M65.8829 27.7019H66.5754V31.4356H65.8829V29.8699H63.6848V31.4356H62.9922V27.7019H63.6848V29.2376H65.8829V27.7019Z"
            fill="#1A1A1A" />
          <path
            d="M71.3326 28.786H70.5798C70.369 28.4246 70.0378 28.244 69.5861 28.244C69.2248 28.244 68.9237 28.3644 68.6828 28.6354C68.4419 28.8763 68.3215 29.2075 68.3215 29.5689C68.3215 29.9603 68.4419 30.2614 68.6828 30.5023C68.9237 30.7432 69.2248 30.8937 69.5861 30.8937C70.0378 30.8937 70.369 30.7131 70.5798 30.3518H71.3326C71.182 30.7131 70.9712 31.0142 70.6701 31.225C70.369 31.4358 70.0077 31.5562 69.5861 31.5562C69.0441 31.5562 68.5624 31.3755 68.201 30.9841C67.8397 30.6227 67.6289 30.141 67.6289 29.5689C67.6289 28.9968 67.8096 28.5451 68.201 28.1537C68.5624 27.7923 69.0441 27.5815 69.5861 27.5815C70.0077 27.5815 70.369 27.702 70.6701 27.9128C70.9712 28.1537 71.2121 28.4246 71.3326 28.786Z"
            fill="#1A1A1A" />
          <path
            d="M74.4659 26.0159H75.1584V27.7021H75.5197C76.0918 27.7021 76.5736 27.8828 76.9349 28.2441C77.2963 28.6054 77.5071 29.027 77.5071 29.569C77.5071 30.1411 77.3264 30.5927 76.965 30.924C76.6037 31.2552 76.122 31.4358 75.5197 31.4358H75.1584V33.0919H74.4659V31.4358H74.1045C73.4722 31.4358 72.9904 31.2552 72.6592 30.924C72.2979 30.5927 72.1172 30.1411 72.1172 29.569C72.1172 29.027 72.2979 28.5753 72.6893 28.2441C73.0506 27.8828 73.5324 27.7021 74.1045 27.7021H74.4659V26.0159ZM74.4659 28.3344H74.1045C73.7131 28.3344 73.3819 28.4549 73.141 28.6957C72.9001 28.9366 72.7796 29.2377 72.7796 29.5991C72.7796 29.9604 72.9001 30.2615 73.1109 30.5024C73.3216 30.7433 73.6528 30.8637 74.0744 30.8637H74.4357V28.3344H74.4659ZM75.5197 28.3344H75.1584V30.8336H75.5197C75.9413 30.8336 76.2725 30.7132 76.4833 30.4723C76.694 30.2314 76.8145 29.9303 76.8145 29.569C76.8145 29.2076 76.6941 28.9065 76.4532 28.6656C76.2424 28.4549 75.9112 28.3344 75.5197 28.3344Z"
            fill="#1A1A1A" />
          <path
            d="M80.2756 30.8936C80.7272 30.8936 81.0585 30.7129 81.2692 30.3817H82.022C81.9016 30.743 81.6607 31.014 81.3596 31.2248C81.0584 31.4356 80.6971 31.5259 80.2756 31.5259C79.7035 31.5259 79.2518 31.3452 78.8604 30.9538C78.499 30.5925 78.3184 30.1107 78.3184 29.5386C78.3184 28.9665 78.499 28.5148 78.8604 28.1234C79.2217 27.7319 79.6734 27.5513 80.2455 27.5513C80.7574 27.5513 81.209 27.7319 81.5704 28.0933C81.9317 28.4546 82.0822 28.9063 82.0822 29.4483C82.0822 29.5988 82.0822 29.7193 82.0521 29.7494H79.041C79.0711 30.0505 79.2217 30.3215 79.4626 30.5021C79.7035 30.8032 79.9745 30.8936 80.2756 30.8936ZM80.2455 28.2438C79.9142 28.2438 79.6734 28.3342 79.4325 28.5148C79.2217 28.6955 79.1013 28.9364 79.041 29.2375H81.3295C81.2993 28.9364 81.1789 28.6955 80.9681 28.5148C80.7875 28.3342 80.5466 28.2438 80.2455 28.2438Z"
            fill="#1A1A1A" />
          <path
            d="M83.8293 33.0918H83.1367V27.702H83.8293V28.0934C84.1304 27.7622 84.5519 27.5815 85.0939 27.5815C85.6961 27.5815 86.1478 27.7622 86.479 28.1537C86.8102 28.5451 86.9909 28.9968 86.9909 29.5388C86.9909 30.0808 86.8102 30.5625 86.479 30.9239C86.1478 31.3153 85.666 31.496 85.0939 31.496C84.5519 31.496 84.1304 31.3153 83.8293 30.9841V33.0918ZM84.1906 28.6053C83.9497 28.8462 83.8293 29.1473 83.8293 29.599C83.8293 30.0205 83.9497 30.3517 84.1906 30.5926C84.4315 30.8335 84.7326 30.9239 85.0939 30.9239C85.4553 30.9239 85.7263 30.8034 85.9672 30.5324C86.208 30.2614 86.2984 29.9603 86.2984 29.599C86.2984 29.2376 86.1779 28.9064 85.9672 28.6655C85.7564 28.4247 85.4553 28.2741 85.0939 28.2741C84.7326 28.244 84.4315 28.3644 84.1906 28.6053Z"
            fill="#1A1A1A" />
          <path
            d="M91.8682 28.9666L90.6638 31.4356H89.9712L88.7668 28.9666V31.4356H88.0742V27.7019H88.8571L90.3325 30.713L91.808 27.7019H92.5909V31.4356H91.8983V28.9666H91.8682Z"
            fill="#1A1A1A" />
          <path
            d="M95.3622 27.6118C95.9041 27.6118 96.3257 27.7323 96.6569 28.0033C96.9882 28.2743 97.1387 28.6055 97.1387 29.0872V31.466H96.4462V31.0746C96.1451 31.4058 95.6934 31.5864 95.1514 31.5864C94.6997 31.5864 94.3384 31.466 94.0373 31.2552C93.7663 31.0445 93.6157 30.7434 93.6157 30.3218C93.6157 29.9002 93.7663 29.5991 94.0674 29.3884C94.3685 29.2077 94.76 29.0872 95.2417 29.0872H96.416C96.416 28.5151 96.0547 28.2441 95.332 28.2441C95.0912 28.2441 94.8804 28.3044 94.6997 28.3947C94.5191 28.485 94.3685 28.6356 94.3083 28.7861H93.5254C93.6157 28.4248 93.8566 28.1237 94.1879 27.9129C94.5492 27.7021 94.9406 27.6118 95.3622 27.6118ZM96.4462 29.9605V29.7196H95.2718C94.6395 29.7196 94.3384 29.9304 94.3384 30.3218C94.3384 30.7132 94.6395 30.924 95.2417 30.924C95.6031 30.924 95.9042 30.8337 96.1451 30.653C96.3558 30.4723 96.4462 30.2315 96.4462 29.9605Z"
            fill="#1A1A1A" />
          <path
            d="M99.0656 33.0918H98.373V27.702H99.0656V28.0934C99.3667 27.7622 99.7883 27.5815 100.33 27.5815C100.932 27.5815 101.384 27.7622 101.715 28.1537C102.047 28.5451 102.227 28.9968 102.227 29.5388C102.227 30.0808 102.047 30.5625 101.715 30.9239C101.384 31.3153 100.902 31.496 100.33 31.496C99.7883 31.496 99.3667 31.3153 99.0656 30.9841V33.0918ZM99.4269 28.6053C99.186 28.8462 99.0656 29.1473 99.0656 29.599C99.0656 30.0205 99.186 30.3517 99.4269 30.5926C99.6678 30.8335 99.9689 30.9239 100.33 30.9239C100.692 30.9239 100.963 30.8034 101.203 30.5324C101.444 30.2614 101.535 29.9603 101.535 29.599C101.535 29.2376 101.414 28.9064 101.203 28.6655C100.993 28.4247 100.692 28.2741 100.33 28.2741C99.9689 28.244 99.6678 28.3644 99.4269 28.6053Z"
            fill="#1A1A1A" />
          <path
            d="M103.281 27.7019H103.974V29.3279L105.78 27.7019H106.714L104.636 29.5688L106.714 31.4356H105.78L103.974 29.9V31.4356H103.281V27.7019Z"
            fill="#1A1A1A" />
          <path
            d="M109.092 30.8936C109.544 30.8936 109.875 30.7129 110.086 30.3817H110.838C110.718 30.743 110.477 31.014 110.176 31.2248C109.875 31.4356 109.514 31.5259 109.092 31.5259C108.52 31.5259 108.068 31.3452 107.677 30.9538C107.315 30.5925 107.135 30.1107 107.135 29.5386C107.135 28.9665 107.315 28.5148 107.677 28.1234C108.038 27.7319 108.49 27.5513 109.062 27.5513C109.574 27.5513 110.025 27.7319 110.387 28.0933C110.748 28.4546 110.899 28.9063 110.899 29.4483C110.899 29.5988 110.899 29.7193 110.868 29.7494H107.857C107.888 30.0505 108.038 30.3215 108.279 30.5021C108.49 30.8032 108.761 30.8936 109.092 30.8936ZM109.032 28.2438C108.701 28.2438 108.46 28.3342 108.219 28.5148C108.008 28.6955 107.888 28.9364 107.827 29.2375H110.116C110.086 28.9364 109.965 28.6955 109.754 28.5148C109.604 28.3342 109.333 28.2438 109.032 28.2438Z"
            fill="#1A1A1A" />
          <path d="M111.352 28.3342V27.7019H114.935V28.3342H113.489V31.4658H112.797V28.3342H111.352Z" fill="#1A1A1A" />
        </svg>
      </router-link>
      <div class="mob__links">
        <a class="mob__setting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.5 7.59163V12.4C2.5 14.1666 2.5 14.1666 4.16667 15.2916L8.75 17.9416C9.44167 18.3416 10.5667 18.3416 11.25 17.9416L15.8333 15.2916C17.5 14.1666 17.5 14.1666 17.5 12.4083V7.59163C17.5 5.8333 17.5 5.8333 15.8333 4.7083L11.25 2.0583C10.5667 1.6583 9.44167 1.6583 8.75 2.0583L4.16667 4.7083C2.5 5.8333 2.5 5.8333 2.5 7.59163Z"
              stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.34"
              d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
              stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
        <a class="mob__burger" :class="{ active: isActive }" @click="toggleActive">
          <svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H14V2H0V0ZM0 4H14V6H0V4Z" fill="#1A1A1A" />
          </svg>
        </a>
      </div>
    </div>
    <BurgerMenuAcc :is-active="isActive" @close-menu="closeMenu" />
  </div>
</template>

<style scoped lang="scss">
.searchInput {
  position: relative;
  z-index: 5;
  width: 364px;
  flex-shrink: 0;
}

.search_Input {
  border-radius: 15px;
  border: 1px solid #e7ecee;
  background: #fff;
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  padding: 19px 40px 19px 20px;
  width: 100%;
}

.searchBtn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background: none;
  border: none;
}

.headerAcc {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 30px 0;
}

.links {
  display: flex;
  gap: 50px;
  margin-left: auto;
}

.btns__items {
  display: flex;
  gap: 20px;
  align-items: center;
}

.links__items {
  display: flex;
  gap: 50px;
  align-items: center;
}

.links__item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-decoration-line: underline;
  position: relative;
  cursor: pointer;
}

.links__item-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.user-menu {
 width: 203px;
 box-shadow: 0px 0px 18.4px 0px rgba(0, 0, 0, 0.14);
 position: absolute;
 top: -240px;
 left: 0;
 background: #fff;
 border-radius: 15px;
 padding: 22px 10px;
 display: flex;
 flex-direction: column;
 transition: .3s all;
  opacity: 0;
}
.user-menu.active {
  top: 63px;
  opacity: 1;
  z-index: 99;
}
.user-menu a {
  padding: 8px 10px;
  display: flex;
  gap:10px;
  align-items: center;
  font-family: Aeroport;
  font-size: 16px;
  font-weight: 300;
  line-height: 21.87px;
  text-align: left;
  color: rgba(30, 31, 34, 1);
  background: transparent;
  transition: .3s all;
  border-radius: 15px;
  width: 100%;
}
.user-menu a:hover {
  background: rgba(231, 236, 238, 1);
}

.links__item span {
  border-radius: 10px;
  background: #1a1a1a;
  padding: 8px;
  display: flex;
}

.burger {
  width: 60px;
  height: 60px;
  border-radius: 15px;
  background: #1a1a1a;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  svg {
    transition: all 0.3s ease;
  }

  &.active {
    z-index: 11;

    svg {
      transform: rotate(-45deg);
    }
  }
}

.mob {
  display: none;

}


@media (max-width: 1440px) {
  .links {
    gap: 15px;
  }

  .links__items {
    gap: 15px;
  }

  .searchInput {
    width: 200px;
  }
}

@media (max-width: 1200px) {
  .searchInput {
    display: none;
  }

  .links {
    display: none;
  }

  .headerAcc {
    gap: 0;
    padding: 20px 0;
  }

  .mob {
    display: flex;
    justify-content: space-between;
    gap: 30px;
    align-items: center;
    width: 100%;

    &__links {
      display: flex;
      gap: 10px;
      align-items: center;

      a {
        width: 38px;
        height: 38px;
        background: rgba(231, 236, 238, 1);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__burger {
      transition: .3s all;

      svg {
        transition: .3s all;
      }

      &.active {
        z-index: 11;
        background: rgba(26, 26, 26, 1);

        svg {
          transform: rotate(-45deg);

          path {
            stroke: #fff;
          }
        }
      }
    }
  }
}
</style>